import { createAction } from 'redux-act';

export const setLoading = createAction('property/SET_LOADING');
export const fetchProperty = createAction('property/FETCH_PROPERTY');
export const fetchPropertySuccess = createAction('property/FETCH_PROPERTY_SUCCESS');
export const clearProperty = createAction('property/CLEAR_PROPERTY');
